import React from "react";
import { Link } from "react-router-dom";

export default function CustomButton({
  name,
  textBlack = false,
  link,
  nofollow = false,
}) {
  return (
    <Link
      reloadDocument
      to={link}
      rel={nofollow ? "noopener noreferrer nofollow" : ""}
      className={`border ${
        textBlack ? "border-black" : "border-white"
      }w-full flex flex-row items-center px-2 py-2 justify-center gap-2 group cursor-pointer`}
    >
      <span
        className={`${
          textBlack ? "text-black" : "text-white"
        }  uppercase text-xs md:text-sm 2xl:text-xl font-[optima-lt-pro] group-hover:text-bhagwa`}
      >
        {name}
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className={`size-4 2xl:size-8 ${
          textBlack ? "text-black" : "text-white"
        }  group-hover:text-bhagwa group-hover:translate-x-1 trabsition-transform duration-300`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.25 4.5 7.5 7.5-7.5 7.5"
        />
      </svg>
    </Link>
  );
}
